import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DateUtils } from '../../../../shared/helpers/dateUtils';
import { EYesNo } from '../../../../shared/models/types.enum';
import { IAssessScreen } from '../../../../shared/models/assessScreen';

@Component({
  selector: 'required-assessments',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './required-assessments.component.html',
  styleUrl: './required-assessments.component.css'
})
export class RequiredAssessmentsComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('datepickerWhen') datepickerWhen!: ElementRef;
  yesNo = EYesNo;
  
  @Input() assessScreenData: any;
  @Output() onSaveSection3 = new EventEmitter<IAssessScreen>();

  requiredForm: FormGroup = new FormGroup({});
  constructor(
    private cdr: ChangeDetectorRef,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
    this.onChanges();
  }  

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['assessScreenData'] && this.assessScreenData) {
      this.initializeForm();
    }
  }  
  
  ngAfterViewInit(): void {
    // apply flowbite date picker when DOM is fully loaded
    this.initializeDatepicker();
  }  

  private initializeForm(): void {
    // radio input for each question
    this.requiredForm = new FormGroup({
      suicide_risk_assessment: new FormControl(String(this.assessScreenData.suicide_risk_assessment) || this.yesNo.No, Validators.required),
      suicide_risk_assessment_person: new FormControl(this.assessScreenData.suicide_risk_assessment_person || ''),
      suicide_risk_assessment_date: new FormControl(this.assessScreenData.suicide_risk_assessment_date || null),
      full_team_threat_assessment: new FormControl(String(this.assessScreenData.full_team_threat_assessment) || this.yesNo.No, Validators.required),
    })

    this.onChanges();

  }

  onChanges(): void {
    this.requiredForm.get('suicide_risk_assessment')!.valueChanges.subscribe(val => {
      if (val == this.yesNo.Yes) {
        this.requiredForm.get('suicide_risk_assessment_person')?.enable();
        this.requiredForm.get('suicide_risk_assessment_person')?.setValidators(Validators.required);
        this.requiredForm.get('suicide_risk_assessment_date')?.enable();
        this.requiredForm.get('suicide_risk_assessment_date')?.setValue(DateUtils.formatDateForBackend(DateUtils.getCurrentFormattedDate()));
        this.requiredForm.get('suicide_risk_assessment_date')?.setValidators(Validators.required);
      } else {
        this.requiredForm.get('suicide_risk_assessment_person')?.disable();
        this.requiredForm.get('suicide_risk_assessment_person')?.clearValidators();
        this.requiredForm.get('suicide_risk_assessment_person')?.setValue(null);
        this.requiredForm.get('suicide_risk_assessment_date')?.disable();
        this.requiredForm.get('suicide_risk_assessment_date')?.clearValidators();
        this.requiredForm.get('suicide_risk_assessment_date')?.setValue(null);
      }
      this.cdr.detectChanges(); // Manually trigger change detection
      this.initializeDatepicker(); // apply flowbite date picker when form change
    });
  }

  async initializeDatepicker() {
    const { Datepicker } = await import('flowbite-datepicker');
    if (this.datepickerWhen?.nativeElement) {
      new Datepicker(this.datepickerWhen.nativeElement, {
        autohide: true,
        format: 'mm/dd/yyyy'
      });
      // set default value to display for incident date
      if (this.assessScreenData?.suicide_risk_assessment_date) {
        // if date_of_incident is available, set it to the datepicker
        this.datepickerWhen.nativeElement.value = DateUtils.formatDateForDisplay(this.assessScreenData.suicide_risk_assessment_date);
      } else {
        // if date_of_incident is not available, set it to the current date
        this.datepickerWhen.nativeElement.value = DateUtils.getCurrentFormattedDate();
      }
      this.datepickerWhen.nativeElement.addEventListener('changeDate', (event: any) => {
        const formattedDate = DateUtils.formatDateForBackend(event.target.value);
        this.requiredForm.get('suicide_risk_assessment_date')?.setValue(formattedDate);
      });
    }
  } 
  
  saveRequired(): void {
    if (this.requiredForm.invalid) {
      return;
    } else {
      this.onSaveSection3.emit(this.requiredForm.value);
    }
  }
  
}
